import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { TASK_ASSIGNMENT } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { TASK_ASSIGNMENT_API } from '../../utils/apiUrl';

export const taskAssignmentGetAllAction = createAsyncThunk(
    TASK_ASSIGNMENT.GET_ALL,
    async (_, { rejectWithValue }) => {
        try {
            const data = await Get(TASK_ASSIGNMENT_API.GET_ALL, null, null);
            if (!data) {
                return rejectWithValue('Không lấy được phân công công việc');
            }
            return data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const taskAssignmentCreateAction = createAsyncThunk(
    TASK_ASSIGNMENT.CREATE,
    async (model, { rejectWithValue }) => {
        try {
            const res = await Post(
                TASK_ASSIGNMENT_API.CREATE,
                null,
                model,
                false
            );

            if (res && typeof res.status === 'number') {
                if (res.status >= 200 && res.status < 300) {
                    let body = null;
                    try {
                        body = await res.json();
                    } catch (_) {}
                    return body || model;
                }

                let errBody = null;
                try {
                    errBody = await res.json();
                } catch (_) {}
                return rejectWithValue(
                    errBody || 'Tạo phân công công việc thất bại'
                );
            }

            if (!res)
                return rejectWithValue('Tạo phân công công việc thất bại');

            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const taskAssignmentUpdateAction = createAsyncThunk(
    TASK_ASSIGNMENT.UPDATE,
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Put(TASK_ASSIGNMENT_API.UPDATE, id, data);

            if (res && typeof res.status === 'number') {
                if (res.status >= 200 && res.status < 300) {
                    let body = null;
                    try {
                        body = await res.json();
                    } catch (_) {}
                    return body || { id, ...data };
                }

                let errBody = null;
                try {
                    errBody = await res.json();
                } catch (_) {}
                return rejectWithValue(
                    errBody || 'Cập nhật phân công công việc thất bại'
                );
            }

            if (!res)
                return rejectWithValue('Cập nhật phân công công việc thất bại');

            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const taskAssignmentDeleteAction = createAsyncThunk(
    TASK_ASSIGNMENT.DELETE,
    async (id, { rejectWithValue }) => {
        try {
            const res = await DeleteSingle(
                TASK_ASSIGNMENT_API.DELETE,
                id,
                null
            );

            if (res && typeof res.status === 'number') {
                if (res.status === 200 || res.status === 204) {
                    return id;
                }

                let errBody = null;
                try {
                    errBody = await res.json();
                } catch (_) {}
                return rejectWithValue(
                    errBody || 'Xoá phân công công việc thất bại'
                );
            }

            if (!res)
                return rejectWithValue('Xoá phân công công việc thất bại');

            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const initialState = {
    list: [],
    loading: false,
    error: null,
};

export const taskAssignmentSlice = createSlice({
    name: TASK_ASSIGNMENT.NAME_SLICE,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(taskAssignmentGetAllAction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(taskAssignmentGetAllAction.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload || [];
            })
            .addCase(taskAssignmentGetAllAction.rejected, (state, action) => {
                state.loading = false;
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Lỗi khi tải phân công công việc';
            })

            .addCase(taskAssignmentCreateAction.fulfilled, (state, action) => {
                if (action.payload) {
                    state.list.push(action.payload);
                }
            })
            .addCase(taskAssignmentCreateAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Tạo phân công công việc thất bại';
            })

            .addCase(taskAssignmentUpdateAction.fulfilled, (state, action) => {
                const updated = action.payload;
                if (!updated || !updated.id) return;

                const idx = state.list.findIndex((x) => x.id === updated.id);
                if (idx >= 0) {
                    state.list[idx] = { ...state.list[idx], ...updated };
                }
            })
            .addCase(taskAssignmentUpdateAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Cập nhật phân công công việc thất bại';
            })

            .addCase(taskAssignmentDeleteAction.fulfilled, (state, action) => {
                const id = action.payload;
                state.list = state.list.filter((x) => x.id !== id);
            })
            .addCase(taskAssignmentDeleteAction.rejected, (state, action) => {
                state.error =
                    action.payload ||
                    action.error?.message ||
                    'Xoá phân công công việc thất bại';
            });
    },
});

export default taskAssignmentSlice.reducer;
